import { useEffect, useRef, useState } from 'react'

export function useOverflowState(deps = []) {
  const ref = useRef(null)
  const [state, setState] = useState({ hasOverflow: false, atStart: true, atEnd: true })

  const update = () => {
    const el = ref.current
    if (!el) return
    const hasOverflow = el.scrollWidth > el.clientWidth + 1
    const atStart = el.scrollLeft <= 1
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1
    setState({ hasOverflow, atStart, atEnd })
  }

  useEffect(() => {
    update()
    const el = ref.current
    if (!el) return
    el.addEventListener('scroll', update, { passive: true })

    const ro = new ResizeObserver(update)
    ro.observe(el)

    return () => {
      el.removeEventListener('scroll', update)
      ro.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(update, deps)

  return { ref, ...state, update }
}

const fadePx = 100

export const buildMask = (showLeftFade, showRightFade) =>
  `linear-gradient(to right,
    ${showLeftFade ? 'transparent' : 'black'} 0,
    black ${fadePx}px,
    black calc(100% - ${fadePx}px),
    ${showRightFade ? 'transparent' : 'black'} 100%)`
